<template v-if="this.user.loggedIn">
  <div class="container">
    <h1 class="text-center mb-3">Eingang</h1>
    <div v-if="message.success !== undefined">
      <div class="alert alert-success fixed-top text-center" role="alert">
        {{ message.success }}
      </div>
    </div>
    <div v-if="message.error !== undefined">
      <div class="alert alert-danger fixed-top text-center" role="alert">
        {{ message.error }}
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center my-3">
      <b-button variant="primary" @click="getMails">
        <font-awesome-icon :icon="['fas', 'envelope']" v-if="!loadingMails" /><font-awesome-icon
          :icon="['fas', 'envelope-open']" v-else />
        <span v-if="loadingMails">&nbsp;<b-spinner small label="Lade..."></b-spinner></span><span
          v-if="!loadingMails">&nbsp;Mails abrufen</span>
      </b-button>
    </div>
    <div class="card">
      <div v-if="!dataArray" class="d-flex justify-content-center p-3" style="width: 100%">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <div>
          <label for="searchInput" class="d-none">Suchen:</label>
          <b-form-input type="text" id="searchInput" placeholder="Suche..." v-model="searchQuery"></b-form-input>
        </div>
        <div class="table-responsive">
        <table class="table table-hover m-0 applications-table">
          <thead>
            <tr>
              <th class="col-name">Name</th>
              <th class="col-joboffer">Stelle</th>
              <th class="col-department">Abteilung</th>
              <th class="col-incoming">Eingang</th>
              <th class="col-status">Status</th>
              <th class="col-keywords">Stichwort</th>
              <th class="col-action"></th>
            </tr>
          </thead>
          <tbody>
            <tr @click="createNew(item?.id)" v-for="(item, index) in filteredApplications" :key="index">
              <td class="name-cell">
                <span v-if="item?.firstname">{{
                  item?.firstname + " " + item?.name
                  }}</span>
                <span v-else>{{ item?.email }}</span>
              </td>
              <td class="joboffer-names">
                {{ item?.jobOfferName }} <br v-if="item.couldAlsoFitFor" /><span v-if="item.couldAlsoFitFor">
                  <b-badge variant="info" v-for="(fit, index) in item.couldAlsoFitFor" :key="index">{{ fit }}</b-badge>
                </span>
              </td>
              <td>
                {{ item?.department }}
                <template v-if="item?.trainee"><br /><b-badge>Ausbildung</b-badge></template>
                <template v-if="item?.internship"><br /><b-badge>Praktikum</b-badge></template>
              </td>
              <td>{{ convert(item.incoming.toDate()) }}</td>
              <td>
                <span :class="'circle ' + setColorByStatus(item.status)"></span><br />{{ applyStatus(item.status) }}
              </td>
              <td class="pr-0">
                <div class="overflow-auto keyword-list">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between border-0 small"
                      v-for="(keyword, index) in item?.keywords" :key="index">
                      <span>
                        {{ index +
                          1 }}. {{
                          keyword
                        }}
                      </span>
                    </li>
                  </ul>
                </div>
              </td>
              <td class="col-action">
                <div v-if="
                  item?.reply &&
                  (!item?.emails ||
                    !item?.emails.some((email) => email?.read === false))
                ">
                  <font-awesome-icon :icon="['fas', 'reply']" />
                </div>
                <div v-else-if="
                  item?.emails &&
                  item?.emails.some((email) => email?.read === false)
                ">
                  <span class="badge badge-pill badge-danger">{{
                    item?.emails.filter((email) => email?.read === false).length
                    }}</span>
                </div>
                <div v-else>
                  <span class="badge badge-pill badge-danger">NEW</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>

    <b-modal size="xl" tabindex="-1" role="dialog" v-model="formularModal" :title="jobOfferName" aria-hidden="true"
      hide-footer @hidden="loadData()">
      <div v-if="personData == '' || personData == undefined" class="d-flex justify-content-center p-3"
        style="width: 100%">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-if="personData !== '' && personData !== undefined" class="" style="width: 100%">
        <div id="printMe">
          <h4 class="printOnly">{{ jobOfferName }}</h4>
          <b-form-group label="Stelle auswählen" v-if="!jobOfferName">
            <b-form-select v-if="jobOptions.length > 0" v-model="selectedJobId" :options="filteredJobOptionsByStatusOnline" text-field="text"
              value-field="value" @change="applyJobData" class="mb-3" />
          </b-form-group>
          <div>
            <p class="m-0"><b>Name</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.firstname + " " + personData?.name }}</p>
            </div>
            <div v-else>
              <b-form-input v-model="personData.firstname" placeholder="Vorname" class="mb-1" />
              <b-form-input v-model="personData.name" placeholder="Nachname" />
            </div>
            <p v-if="personData?.birthday" class="m-0"><b>Geburtstag</b></p>
            <p>{{ personData?.birthday }}</p>
            <p v-if="personData?.street" class="m-0"><b>Adresse</b></p>
            <p v-if="personData?.street" class="m-0">
              {{ personData?.street }}
            </p>
            <p v-if="personData?.town" class="m-0">
              {{ personData?.zip + " " + personData?.town }}
            </p>
            <p>{{ personData?.country }}</p>
            <p class="m-0"><b>Telefon</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.phonenumber }}</p>
            </div>
            <div v-else>
              <b-form-input v-model="personData.phonenumber" placeholder="Telefonnummer eingeben" />
            </div>
            <p v-if="personData?.email" class="mt-2"><b>E-Mail</b></p>
            <p>{{ personData?.email }}</p>
          </div>
          <div v-if="personData?.image">
            <ImageBlob :data="{ image: personData?.image }" />
          </div>
          <hr v-if="personData?.coverLetter" />
          <div v-if="personData?.privacyPolicy">
            <p><b>Anschreiben</b></p>
            <div v-html="personData?.coverLetter"></div>
          </div>
          <b-button variant="success" class="mt-2" @click="saveMissingFields()"
            v-if="changed && !changePersonData">Speichern</b-button>
          <div class="printOnly">
            <hr />
            <p class="m-0"><b>Anlagen</b></p>
            <p v-if="personData?.curriculumVitae" class="m-0">
              <small>Lebenslauf</small>
            </p>
            <div v-for="(item, index) in personData?.otherDocuments" :key="index">
              <p class="m-0">
                <small>{{ item.name }} </small>
              </p>
            </div>
          </div>
        </div>
        <hr v-if="personData?.curriculumVitae" />
        <p v-if="personData?.curriculumVitae || personData?.otherDocuments">
          <b>Datein</b>
        </p>
        <ButtonBlob :data="{ data: personData?.curriculumVitae }" v-if="personData?.curriculumVitae" />
        <DropDownButtonBlob :data="personData?.otherDocuments" v-if="personData?.otherDocuments.length > 0" />
        <hr />
        <p><b>Aktionen</b></p>
        <b-button v-if="personData?.email" variant="outline-primary" @click="replyMe(personId)"
          class="m-1"><font-awesome-icon :icon="['fas', 'reply']" /> Antworten</b-button>
        <b-button variant="outline-secondary" @click="archivateMe(personId)" class="m-1"><font-awesome-icon
            :icon="['fas', 'archive']" />
          Archivieren</b-button>
        <!-- <b-button variant="outline-dark" @click="generateReport()" class="m-1"><font-awesome-icon :icon="['fas', 'print']" /> Drucken</b-button> -->
        <b-button variant="outline-danger" @click="deleteMe(personId)" class="m-1"><font-awesome-icon
            :icon="['fas', 'trash']" /> Löschen</b-button>
        <b-button variant="outline-dark" @click="openMailToAl()" class="m-1"><font-awesome-icon
            :icon="['fas', 'user-tie']" /> Freigabe für
          AL</b-button>
        <b-button variant="outline-secondary" @click="addToPool(personId)" class="m-1"><font-awesome-icon
            :icon="['fas', 'users']" /> Zum Pool
          hinzufügen</b-button>
        <b-button variant="outline-secondary" @click="addToTalentsPool(personId)" class="m-1"><font-awesome-icon
            :icon="['fas', 'users']" /> Zum Talente-Pool
          hinzufügen</b-button>
        <b-button variant="outline-secondary" @click="addToEmployedArchive(personId)" class="m-1"><font-awesome-icon
            :icon="['fas', 'archive']" /> Zum
          Eingestellt-Archiv hinzufügen</b-button>
        <b-button variant="outline-info" @click="changePersonData = true" class="m-1"><font-awesome-icon
            :icon="['fas', 'user-edit']" /> Personendaten
          ändern</b-button>
        <b-button variant="outline-info" @click="uploadDocuments = true" class="m-1"><font-awesome-icon
            :icon="['fas', 'file-upload']" /> Dokumente
          ergänzen</b-button>
        <b-button variant="outline-info" @click="openCouldAlsoFitForModal()" class="m-1"><font-awesome-icon
            :icon="['fas', 'user-edit']" /> Weitere Stelle
          hinzufügen</b-button>
        <b-button variant="outline-warning" @click="removeOpenReply = true" class="m-1"><font-awesome-icon
            :icon="['fas', 'envelope-open']" /> Antwort
          erhalten</b-button>
        <div class="mt-3">
          <b-form-select v-model="selectedStatus" :options="statusOptions" v-on:change="updateStatus"></b-form-select>
        </div>
        <div v-if="personData.releaseMails" class="mt-3">
          <p>An folgende Personen wurde bereits eine Freigabe verschickt:</p>
          <ul>
            <li v-for="(item, index) in [
              ...new Map(
                personData.releaseMails.map((obj) => [obj.mail, obj]),
              ).values(),
            ]" :key="index">
              {{ item.mail }} <br />
              <span>Antwort(en): {{ getAnswerOfAl(item.mail) }}</span>
            </li>
          </ul>
        </div>
        <div class="mt-3" v-if="personData">
          <hr />
          <p><b>Notizen</b></p>
          <b-form-textarea id="notes-textarea" placeholder="Notizen..." v-model="personData.notes" rows="2"
            max-rows="6"></b-form-textarea>
          <b-button variant="outline-success" class="mt-2" @click="saveNotes()"
            :disabled="!notesChanged || !personData.notes">Speichern</b-button>
        </div>
        <div class="mt-3" v-if="personData">
          <hr />
          <p><b>Stichwörter</b></p>
          <b-list-group v-if="savedKeywords.length > 0" class="mb-3">
            <b-list-group-item v-for="(keyword, index) in savedKeywords" :key="index"
              class="d-flex justify-content-between align-items-center pr-3 pl-3 list-group-item-action">
              <span>
                {{ index + 1 }}. {{
                  keyword
                }}
              </span>
              <b-button size="sm" variant="outline-danger" @click="deleteKeyword(keyword)"
                class="m-1"><font-awesome-icon :icon="['fas', 'trash']" /> Löschen</b-button>
            </b-list-group-item>
          </b-list-group>
          <div class="d-flex align-items-center">
            <b-form-input class="w-50 mr-2" v-model="personData.keyword" maxlength="40"
              placeholder="Stichwort..."></b-form-input>
            <p class="d-flex w-50 justify-content-center align-items-center m-0"><small v-if="personData.keyword">{{
              personData.keyword.length
                }}</small><small class="mr-3">/40
                Zeichen</small>
              <small>{{ this.savedKeywords.length }}/5 Stichwörter möglich</small>
            </p>
          </div>
          <b-button variant="outline-success" class="mt-2" @click="saveKeyword()"
            :disabled="!personData.keyword || this.savedKeywords.length >= 5">Stichwort
            hinzufügen</b-button>
        </div>
        <div v-if="mergeEmailsAndReplies(personData).length > 0">
          <hr />
          <p><b>Nachrichten</b></p>

          <div class="accordion" role="tablist" v-for="(data, index) in mergeEmailsAndReplies(personData)" :key="index">
            <!-- <pre>{{data}}</pre> -->
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="`collapse-${index}`" @click="setIsRead(data)" :variant="data?.message ? 'outline-secondary' : 'outline-primary'
                  " class="d-flex justify-content-between">
                  <div v-if="data?.message">Ausgang</div>
                  <div v-else>
                    Eingang
                    <span v-if="data?.read === false"><span class="badge badge-pill badge-danger">1</span></span>
                  </div>
                  <div>
                    {{
                      typeof data?.dateString === "string"
                        ? data.dateString
                        : data.date.toLocaleDateString("de-DE")
                    }}
                  </div>
                  <div></div>
                </b-button>
              </b-card-header>
              <b-collapse :id="`collapse-${index}`" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div>
                    <span v-if="data?.type === 'email'"><b>Von:</b> {{ data.from.name }}
                      {{ data.from.address }}</span><br />
                    <span v-if="data?.type === 'email'"><b>Datum:</b>
                      {{
                        data.date
                          .toLocaleDateString("de-DE", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                          .replace(",", " um")
                      }}</span><br />
                    <span v-if="data?.type === 'email'"><b>An:</b> {{ data.to[0]?.emailAddress.address }}</span><br />
                    <span v-if="data?.type === 'email'"><b>Betreff:</b> {{ data.subject }}</span><br />
                  </div>

                  <b-card-text v-html="parseHTMLandDeleteStyleAndScripts(data?.message || data.body)"></b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl" tabindex="-1" role="dialog" v-model="answerModal" aria-hidden="true" hide-footer>
      <div v-if="personData == '' || personData == undefined" class="d-flex justify-content-center p-3"
        style="width: 100%">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-if="personData !== '' && personData !== undefined" class="" style="width: 100%">
        <p>Flensburg, {{ date }}</p>
        <p><b>Ihre Bewerbung</b></p>
        <p>Hallo {{ personData?.firstname }},</p>

        <div>
          <b-form-select v-model="selected" :options="sortedTemplates"></b-form-select>
          <b-form-textarea id="textarea" placeholder="Schreibe einen Antworttext..." v-model="selected" rows="2"
            max-rows="6"></b-form-textarea>
        </div>
        <br />
        <p>Mit freundlichen Grüßen</p>
        <p>{{ this.user.data.displayName }}</p>
        <hr />
        <b-button variant="outline-primary" :disabled="absendenButton" @click="sendAnswer()" class="m-1">
          <font-awesome-icon :icon="['fas', 'paper-plane']" />
          <span v-if="!loading"> Absenden </span>
          <span v-if="loading">
            <b-spinner small label="Sending..."></b-spinner>
          </span>
        </b-button>
        <b-button variant="outline-warning" class="m-1" @click="openDelayedModal">
          <font-awesome-icon :icon="['fas', 'clock']" /> Später senden
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="delayedModal" title="Verzögerten Versand planen" hide-footer>
      <div>
        <b-form-group label="Anzahl der Tage bis zum Versand:">
          <b-form-input type="number" v-model="daysDelay" min="0"></b-form-input>
        </b-form-group>
        <b-button variant="primary" @click="sendDelayedAnswer">
          <span v-if="!loading"> E-Mail planen </span>
          <span v-if="loading">
            <b-spinner small label="Sending..."></b-spinner>
          </span>
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="mailToAl" title="Freigabe für Abteilungsleiter" hide-footer>
      <div>
        <b-form-group label="E-Mail des Abteilungsleiters:">
          <b-form-input type="email" v-model="mailOfAL" min="0"></b-form-input>
        </b-form-group>
        <b-form-group label="Nachricht (optional):">
          <b-form-textarea v-model="messageTextForAl" rows="4"></b-form-textarea>
        </b-form-group>
        <b-form-checkbox v-model="noAnswerNeededFromAl" class="mb-3">
          Keine Antwort notwendig, nur Freigabe senden
        </b-form-checkbox>
        <b-button variant="primary" @click="sendMailToAL">
          <span v-if="!loading"> Freigabe senden </span>
          <span v-if="loading">
            <b-spinner small label="Sending..."></b-spinner>
          </span>
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="changePersonData" title="Personendaten ändern" hide-footer>
      <div>
        <b-form-group label="Personendaten ändern" v-if="personData">
          <b-form-input type="text" v-model="personData.firstname" placeholder="Vorname"></b-form-input>
          <b-form-input type="text" v-model="personData.name" placeholder="Nachname"></b-form-input>
          <b-form-input type="text" v-model="personData.phonenumber" placeholder="Telefonnummer"></b-form-input>
          <b-form-input type="text" v-model="personData.email" placeholder="E-Mail"></b-form-input>
          <b-form-input type="text" v-model="personData.street" placeholder="Straße"></b-form-input>
          <b-form-input type="text" v-model="personData.zip" placeholder="PLZ"></b-form-input>
          <b-form-input type="text" v-model="personData.town" placeholder="Ort"></b-form-input>
          <b-form-input type="text" v-model="personData.country" placeholder="Land"></b-form-input>
        </b-form-group>
        <b-button variant="primary" @click="savePersonData">
          Änderungen speichern
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="uploadDocuments" title="Dokumente ergänzen" hide-footer>
      <div class="mb-5">
        <b-form-group label="CV hochladen" v-if="personData">
          <b-form-file @change="handleCVUpload"></b-form-file>
        </b-form-group>
        <b-button variant="primary" @click="uploadCV" :disabled="!curriculumVitaeFile.file">
          CV hochladen
        </b-button>
        <p>
          Achtung: Wenn bereits eine Datei vorhanden ist, wird diese hiermit
          überschrieben.
        </p>
      </div>
      <div>
        <b-form-group label="Weitere Dokumente hochladen" v-if="personData">
          <b-form-file multiple @change="handleOtherDocumentsUpload"></b-form-file>
        </b-form-group>
        <b-button variant="primary" @click="uploadPersonOtherDocuments" :disabled="otherDocumentsFiles.length === 0">
          Weitere Dokumente hochladen
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="setCouldAlsoFitForActive" title="Weitere passende Stellen" hide-footer>
      <div>
        <p>Mehrfachauswahl möglich per cmd (Mac) oder Strg (Windows)</p>
        <b-form-group label="Weitere passende Stellen" v-if="personData">
          <b-select v-model="personData.couldAlsoFitFor" multiple
            :options="jobOptions.map((option) => option.text)"></b-select>
        </b-form-group>
        <b-button variant="primary" class="mr-2" @click="setCouldAlsoFitFor()">
          Änderungen speichern
        </b-button>
        <b-button variant="danger" @click="deleteCouldAlsoFitFor()">
          Weitere Stellen entfernen
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="removeOpenReply" title="Antwort erhalten" hide-footer>
      <b-form-group label="E-Mail-Adresse, von der die Antwort eingegangen ist:">
        <b-form-input v-model="replyEmail" placeholder="E-Mail-Adresse"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="removeNeedReplyFrom(replyEmail)" :disabled="!replyEmail">
        Antwort als erhalten markieren
      </b-button>
      <b-button class="ml-2" variant="secondary" @click="removeOpenReply = false">
        Abbrechen
      </b-button>
    </b-modal>
    <!-- <CheckUserName/> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { functions, firestore, storage } from "../plugins/firebase";
import {
  query,
  collection,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  updateDoc,
  where,
  orderBy,
  arrayRemove,
  arrayUnion
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import ImageBlob from "./ImageBlob";
import ButtonBlob from "./ButtonBlob";
import DropDownButtonBlob from "./DropDownButtonBlob";
import { uploadBytes, getDownloadURL, ref } from "firebase/storage";

export default {
  name: "Applications",
  computed: {
    ...mapGetters({
      user: "user",
    }),
    filteredApplications() {
      // Convert object to array and include keys as 'id' property
      const arrayData = Array.isArray(this.dataArray)
        ? this.dataArray
        : Object.entries(this.dataArray || {}).map(([key, value]) => ({
          ...value,
          id: key,
        }));
      if (!this.searchQuery) {
        return arrayData;
      }
      const query = this.searchQuery.toLowerCase();
      return arrayData.filter((app) => {
        const fullName = `${app.firstname} ${app.name}`.toLowerCase();
        const jobOfferName = app.jobOfferName
          ? app.jobOfferName.toLowerCase()
          : "";
        return fullName.includes(query) || jobOfferName.includes(query);
      });
    },
    sortedTemplates() {
      const templates = [...this.textTamplates];
      const firstOption = templates.find((t) => t.value === null);
      const otherOptions = templates
        .filter((t) => t.value !== null)
        .sort((a, b) => a.text.localeCompare(b.text));
      return firstOption ? [firstOption, ...otherOptions] : otherOptions;
    },
    filteredJobOptionsByStatusOnline(){
      return this.jobOptions.filter((job) => job.status === "online");
    }
  },
  components: {
    ImageBlob,
    ButtonBlob,
    DropDownButtonBlob,
  },
  watch: {
    personData: {
      handler(newD) {
        // console.log('personData changed', newD.firstname, this.personDataOriginal.firstname);
        if (
          newD.firstname !== this.personDataOriginal.firstname ||
          newD.name !== this.personDataOriginal.name ||
          newD.phonenumber !== this.personDataOriginal.phonenumber
        )
          this.changed = true;
        if (newD.notes !== this.personDataOriginal.notes)
          this.notesChanged = true;
      },
      deep: true,
    },
  },
  data() {
    return {
      mailOfAL: "",
      mailToAl: false,
      noAnswerNeededFromAl: false,
      changed: false,
      dataArray: undefined,
      message: {
        success: undefined,
        error: undefined,
      },
      messageTextForAl: "",
      formularModal: false,
      answerModal: false,
      personData: undefined,
      personDataOriginal: undefined,
      jobOfferName: undefined,
      date: moment(new Date()).format("DD.MM.YYYY"),
      personId: undefined,
      selected: undefined,
      curriculumVitaeURL: undefined,
      textTamplates: [{ text: "Wähle einen Antworttext...", value: null }],
      absendenButton: false,
      selectedJob: null,
      selectedJobId: null,
      jobOptions: [],
      delayedModal: false,
      daysDelay: 0,
      loading: false,
      statusOptions: [
        { value: null, text: "Status wählen", disabled: true },
        { value: "cancellation", text: "Absage" },
        { value: "checkPossibilities", text: "int. Kapazitäten prüfen" },
        { value: "invitation", text: "Einladen" },
        { value: "invitation-sent", text: "für VG eingeladen" },
        { value: "checkSuperior", text: "Rücksprache mit VG" },
        { value: "pendingReturnMessage", text: "auf RR warten" },
        { value: "secondChoice", text: "Zweite Wahl" },
        { value: "pendingMessageFK", text: "auf FK warten" },
        { value: "pool", text: "in Pool aufnehmen" },
        { value: "phone-call", text: "Anrufen" },
        { value: "request-documents", text: "Unterlagen anfordern" },
        { value: "waiting-for-documents", text: "auf Unterlagen warten" },
        { value: "waiting-for-response", text: "Antwort abwarten" },
        { value: "sarah", text: "Sarah" },
        { value: "lena", text: "Lena" },
        { value: "invite-to-trial-work", text: "Probearbeit einladen" },
        { value: "agreed-trial-work", text: "Probearbeit vereinbart" },
        { value: "create-contract", text: "Vertrag erstellen" },
      ],
      selectedStatus: null,
      searchQuery: "",
      notesChanged: false,
      savedKeywords: [],
      changePersonData: false,
      loadingMails: false,
      uploadDocuments: false,
      curriculumVitaeFile: {
        file: null,
        name: "",
      },
      otherDocumentsFiles: [],
      setCouldAlsoFitForActive: false,
      removeOpenReply: false,
      replyEmail: "",
    };
  },
  methods: {
    parseHTMLandDeleteStyleAndScripts (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const styles = doc.querySelectorAll("style");
      const scripts = doc.querySelectorAll("script");
      styles.forEach((style) => style.remove());
      scripts.forEach((script) => script.remove());
      return doc.body.innerHTML;
    },
    applyJobData() {
      this.changed = true;
      const selected = this.jobOptions.find(
        (j) => j.value === this.selectedJobId,
      );
      if (selected && selected.full) {
        const job = selected.full;
        this.personData.jobOfferName = job.jobOfferName || "";
        this.personData.department = job.department || "";
        this.personData.workingStart = job.workingStart || "";
        this.personData.workingTime = job.workingTime || "";
        this.personData.type = job.type || "";
        this.personData.limited = job.limited || "";
        this.changed = true;
      }
      this.selectedJob = selected;
    },
    async saveMissingFields() {
      if (this.selectedJob) {
        this.personData.jobOfferName = this.selectedJob.value.job;
        this.personData.department = this.selectedJob.value.department;
      }

      await updateDoc(
        doc(firestore, "application", this.personId),
        this.personData,
      )
        .then(() => {
          this.message.success = "Daten wurden ergänzt.";
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Fehler beim Speichern: " + error;
          setTimeout(this.resetMessage, 3000);
        });
      this.changed = false;
    },
    async loadData() {
      this.loadResponses();
      const q = await query(
        collection(firestore, "application"),
        orderBy("incoming"),
        where("archive", "==", false),
      );
      const querySnapshot = await getDocs(q);
      const tempData = {};
      querySnapshot.forEach((doc) => {
        if (doc.data().pool === true) return; // Skip applications in the pool
        if (doc.data().employedArchive === true) return; // Skip applications in the employed archive
        if (doc.data().talentsPool === true) return; // Skip applications in the talents pool
        tempData[doc.id] = doc.data();
      });

      this.dataArray = tempData;
    },
    async loadJobOffers() {
      const q = await query(collection(firestore, "jobOffers"));
      const querySnapshot = await getDocs(q);
      this.jobOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.jobOfferName,
          status: data.status,
          value: {
            job: data.jobOfferName,
            department: data.department,
          },
        };
      });
    },
    async sendMailToAL() {
      const mail = this.mailOfAL.toLowerCase().trim();
      if (mail != undefined && mail != null && mail != "") {
        this.loading = true;
        const findOrCreateUserByEmail = httpsCallable(
          functions,
          "findOrCreateUserByEmail",
        );
        await findOrCreateUserByEmail({ email: mail }).catch(
          (error) => {
            console.error("Error creating or finding user: ", error);
          },
        );
        const sendMailToAl = httpsCallable(functions, "sendMailToAl");
        await sendMailToAl({
          mail: mail,
          applicationId: this.personId,
          message: this.messageTextForAl,
          noAnswerNeededFromAl: this.noAnswerNeededFromAl,
        })
          .then(() => {
            this.message.success =
              "Die E-Mail wurde erfolgreich an den Abteilungsleiter gesendet.";
            this.mailToAl = false;
            this.mailOfAL = "";
            this.messageTextForAl = "";
            setTimeout(this.resetMessage, 3000);
          })
          .catch((error) => {
            this.message.error = "Es ist ein Fehler aufgetreten: " + error;
            setTimeout(this.resetMessage, 3000);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.message.error = "Bitte eine gültige E-Mail-Adresse eingeben.";
        setTimeout(this.resetMessage, 3000);
      }
    },
    async loadResponses() {
      const q = await query(collection(firestore, "responseSelection"));
      const querySnapshot = await getDocs(q);
      const templateOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.title,
          value: data.text,
        };
      });
      this.textTamplates = [
        { text: "Wähle einen Antworttext...", value: null },
        ...templateOptions,
      ];
    },
    openCouldAlsoFitForModal() {
      if (this.personData && !Array.isArray(this.personData.couldAlsoFitFor)) {
        this.$set(this.personData, "couldAlsoFitFor", []);
      }
      this.setCouldAlsoFitForActive = true;
    },
    createNew(id) {
      this.personId = id;
      this.personData = this.filteredApplications.find(
        (app) => app.id === this.personId,
      );
      if (!Array.isArray(this.personData?.couldAlsoFitFor)) {
        this.$set(this.personData, "couldAlsoFitFor", []);
      }
      this.selectedStatus = this.personData?.status
        ? this.personData.status
        : null;
      this.personDataOriginal = JSON.parse(
        JSON.stringify(this.dataArray[this.personId]),
      );
      this.formularModal = !this.formularModal;
      this.jobOfferName = this.personData?.jobOfferName;
      this.curriculumVitaeURL = undefined;
      this.loadApplicationKeywords(this.personId);
    },
    correctSalutaion(salutation) {
      if (salutation === "Herr" || salutation === "Mr") {
        return "geehrter Herr";
      } else {
        return "geehrte Frau";
      }
    },
    salutation(salutation) {
      if (salutation === "Mr") {
        return "Herr";
      } else if (salutation === "Mrs") {
        return "Frau";
      } else {
        return salutation;
      }
    },
    deleteMe(id) {
      let index = id;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.dataArray[index].firstname} Löschen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Löschen",
            cancelTitle: "Behalten",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            this.applicationModal = false;
            deleteDoc(doc(firestore, "/application", `${id}`))
              .then(() => {
                setTimeout(this.resetMessage, 3000);
                this.loadData();
                this.message.success = "Die Daten wurden erfolgreich gelöscht.";
                this.formularModal = null;
              })
              .catch((error) => {
                console.log(error);
                this.message.error =
                  "Es ist ein Fehler aufgetreten.<br>" + error;
                setTimeout(this.resetMessage, 3000);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    replyMe() {
      this.answerModal = !this.answerModal;
    },
    archivateMe(id) {
      let data = this.personData;
      data.archive = true;
      data.archiveDate = new Date();
      data.needReplyFrom = [];

      updateDoc(doc(firestore, "application", id), data)
        .then(() => {
          this.message.success = "Die Daten wurden erfolgreich gespeichert.";
          this.formularModal = null;
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten.<br>" + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    openDelayedModal() {
      this.delayedModal = true;
    },
    openMailToAl() {
      this.mailToAl = true;
    },
    async sendDelayedAnswer() {
      if (!this.selected || !this.personData?.email) {
        this.message.error = "Bitte E-Mail-Text auswählen oder schreiben.";
        setTimeout(this.resetMessage, 3000);
        return;
      }

      const anschreiben =
        "<p><b>Deine Bewerbung</b></p>" +
        "<p>Hallo " +
        this.personData?.firstname +
        ",</p>";
      const verabschiedung =
        "<br><p> Mit freundlichen Grüßen</p>" + this.user.data.displayName;

      const anschreibenPlain =
        "Deine Bewerbung\n\n" + "Hallo " + this.personData?.firstname + ",\n\n";
      const verabschiedungPlain =
        "\n\nMit freundlichen Grüßen\n" + this.user.data.displayName;

      const mailData = {
        to: this.personData?.email,
        subject: "Deine Bewerbung - ComLine GmbH.",
        html: anschreiben + this.selected + verabschiedung,
        text: anschreibenPlain + this.selected + verabschiedungPlain,
        daysDelay: this.daysDelay,
      };

      try {
        this.loading = true;
        const planMail = httpsCallable(functions, "planMail");
        await planMail(mailData);
        this.message.success = `E-Mail wurde für den Versand in ${this.daysDelay} Tag(en) geplant.`;
        this.delayedModal = false;
        this.answerModal = false;
        this.selected = "";
        this.answered(this.personId);
        this.replyed(this.personId, mailData.html);
      } catch (error) {
        this.message.error = "Planung fehlgeschlagen: " + error.message;
      } finally {
        this.loading = false;
      }

      setTimeout(this.resetMessage, 3000);
    },
    setIsRead(data) {
      if (data.type === "email") {
        // Erst das Dokument holen
        getDoc(doc(firestore, "application", this.personId))
          .then((docSnap) => {
            if (docSnap.exists()) {
              const docData = docSnap.data();

              // Index der gewünschten Email-ID in data.in finden
              const emailIndex = data.id;

              if (emailIndex !== -1) {
                // Read-Status für das spezifische Email-Element setzen
                const updatedIn = [...docData.emails];
                updatedIn[emailIndex].read = true;

                // Nur das 'in' Array updaten
                updateDoc(doc(firestore, "application", this.personId), {
                  emails: updatedIn,
                })
                  .then(() => {
                    console.log("setIsRead", updatedIn[emailIndex]);
                  })
                  .catch((error) => {
                    console.warn(error);
                  });
              }
            }
            this.personData.emails[data.id].read = true; // Lokales Update für sofortige UI-Aktualisierung
          })
          .catch((error) => {
            console.warn("Error getting document:", error);
          });
      }
    },
    resetMessage() {
      this.message.success = undefined;
      this.message.error = undefined;
    },
    parseGermanDate(date) {
      return date.toDate();
    },
    // Hilfsfunktion um Timestamp-Objekte zu konvertieren
    convertTimestamp(timestamp) {
      if (timestamp && timestamp.seconds) {
        return new Date(timestamp.seconds * 1000);
      }
      return new Date(timestamp);
    },
    mergeEmailsAndReplies(applicationData, options = {}) {
      const { sortOrder = "asc", includeHtmlContent = true } = options;
      const mergedItems = [];
      const emails = applicationData.emails || [];
      const replies = applicationData.replyed || [];

      // 1) Original-Emails
      emails.forEach((email, idx) => {
        const dt = this.convertTimestamp(
          email.sentDateTime || email.createdDateTime,
        );
        mergedItems.push({
          type: "email",
          id: idx,
          date: dt,
          dateString: dt.toLocaleDateString("de-DE"),
          subject: email.subject,
          from: email.from?.emailAddress || email.sender?.emailAddress,
          to: email.toRecipients,
          body: includeHtmlContent ? email.body?.content : email.bodyPreview,
          read: email.read,
        });
      });

      // 2) Replies (geplant oder sofort)
      // mergeEmailsAndReplies(applicationData, options = {})
      replies.forEach((reply, idx) => {
        let dt = null;

        if (
          typeof reply.sendAt === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.sendAt)
        ) {
          dt = new Date(reply.sendAt.split(".").reverse().join("-"));
        } else if (reply.sendAt instanceof Date) {
          dt = reply.sendAt;
        } else if (reply.sendAt?.toDate) {
          dt = reply.sendAt.toDate();
        }

        // 🔧 HIER NEU: Fallback auf "date" (dein altes Textdatum)
        if (
          !dt &&
          typeof reply.date === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.date)
        ) {
          dt = new Date(reply.date.split(".").reverse().join("-"));
        }

        if (!dt && typeof reply.date === "object") {
          dt = reply.date.toDate();
        }

        if (!dt || isNaN(dt.getTime())) {
          dt = new Date(); // letzter Fallback
        }

        // Für die Anzeige
        const ds = dt.toLocaleDateString("de-DE");

        mergedItems.push({
          type: "reply",
          id: idx,
          date: dt,
          dateString: ds,
          subject: `Re: ${applicationData.jobOfferName || "Bewerbung"}`,
          message: reply.message,
        });
      });

      // 3) Sortierung
      mergedItems.sort((a, b) => {
        return sortOrder === "desc" ? b.date - a.date : a.date - b.date;
      });

      return mergedItems;
    },
    sendAnswer() {
      if (
        this.selected !== undefined &&
        this.selected !== null &&
        this.selected !== ""
      ) {
        this.absendenButton = true;
        const futureDate = moment()
          .add(this.daysDelay, "days")
          .format("DD.MM.YYYY");
        const anschreiben =
          "<p>Flensburg, " +
          futureDate +
          "</p>" +
          "<p><b>Deine Bewerbung</b></p>" +
          "<p>Hallo " +
          this.personData?.firstname +
          ",</p>";

        const verabschiedung =
          "<br><p> Mit freundlichen Grüßen</p>" + this.user.data.displayName;

        const anschreibenPlain =
          "Flensburg, " +
          futureDate +
          "\n" +
          "Deine Bewerbung\n\n" +
          "Hallo " +
          this.personData?.firstname +
          ",\n\n";
        const verabschiedungPlain =
          "\n\nMit freundlichen Grüßen\n" + this.user.data.displayName;

        const mailData = {
          mail: this.personData?.email,
          subject: "Deine Bewerbung - ComLine GmbH.",
          message: anschreiben + this.selected + verabschiedung,
          text: anschreibenPlain + this.selected + verabschiedungPlain,
          html:
            anschreiben +
            this.selected.replace(/(?:\r\n|\r|\n)/g, "<br>") +
            verabschiedung,
          user: this.user.data.email,
        };
        this.loading = true;
        const sendMail = httpsCallable(functions, "sendMail");
        sendMail(mailData)
          .then(() => {
            this.message.success = "Die E-Mail wurde erfolgreich versendet.";
            this.answerModal = false;
            this.selected = "";
            this.answered(this.personId);
            this.replyed(this.personId, mailData.html);
            this.absendenButton = false;
            setTimeout(this.resetMessage, 1000);
            return null;
          })
          .catch((error) => {
            this.absendenButton = false;
            this.message.error = "Die E-Mail konnte nicht versendet werden.";
            setTimeout(this.resetMessage, 1000);
            console.warn(error);
            return null;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.absendenButton = false;
        this.message.error =
          "Bitte Wählen Sie einen Text aus oder Schreiben Sie einen Text.";
        setTimeout(this.resetMessage, 3000);
      }
    },
    generateReport() {
      this.$htmlToPaper("printMe");
    },
    answered(id) {
      let data = this.personData;
      data.reply = true;
      updateDoc(doc(firestore, "application", id), data);
    },
    replyed(id, data) {
      const now = new Date();
      const sendAt =
        this.daysDelay > 0
          ? moment().add(this.daysDelay, "days").toDate()
          : now;

      const replyEntry = {
        createdAt: now,
        sendAt: sendAt,
        message: data,
      };

      let allData = this.personData;
      if (Array.isArray(allData?.replyed)) {
        allData.replyed.push(replyEntry);
      } else {
        allData.replyed = [replyEntry];
      }

      updateDoc(doc(firestore, "application", id), allData);
    },
    convert(data) {
      var date = new Date(data);
      return moment(date).format("DD.MM.YYYY");
    },
    setColorByStatus(status) {
      switch (status) {
        case "cancellation":
          return "red";
        case "checkPossibilities":
          return "yellow";
        case "invitation":
          return "green";
        case "invitation-sent":
          return "lightgreen";
        case "checkSuperior":
          return "orange";
        case "pendingReturnMessage":
          return "turquoise";
        case "secondChoice":
          return "grey";
        case "pendingMessageFK":
          return "blue";
        case "pool":
          return "purple";
        case "phone-call":
          return "black";
        case "request-documents":
          return "magenta";
        case "waiting-for-documents":
          return "brown";
        case "waiting-for-response":
          return "cyan";
        case "sarah":
          return "pink";
        case "lena":
          return "lightblue";
        case "invite-to-trial-work":
          return "lightbrown";
        case "agreed-trial-work":
          return "lightgrey";
        case "create-contract":
          return "lightcoral";
        default:
          return "white";
      }
    },
    async updateStatus() {
      let data = this.personData;
      data.status = this.selectedStatus;
      updateDoc(doc(firestore, "application", this.personId), data)
        .then(() => {
          this.message.success = "Die Daten wurden erfolgreich gespeichert.";
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten. " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    addToPool(id) {
      let data = this.personData;
      data.pool = true;
      data.needReplyFrom = [];
      updateDoc(doc(firestore, "application", id), data)
        .then(() => {
          this.message.success = "Die Daten wurden erfolgreich gespeichert.";
          this.formularModal = null;
          setTimeout(this.resetMessage, 3000);
          this.loadData();
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten: " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    async addToTalentsPool(id) {
      try {
        await updateDoc(doc(firestore, "application", id), {
          talentsPool: true,
          needReplyFrom: [],
        });
        this.message.success =
          "Die Person wurde erfolgreich zum Talent-Pool hinzugefügt.";
        this.formularModal = null;
        setTimeout(this.resetMessage, 3000);
        this.loadData();
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    applyStatus(status) {
      switch (status) {
        case "cancellation":
          return "Absage";
        case "checkPossibilities":
          return "int. Kapazitäten prüfen";
        case "invitation":
          return "Einladen";
        case "invitation-sent":
          return "für VG eingeladen";
        case "checkSuperior":
          return "Rücksprache mit VG";
        case "pendingReturnMessage":
          return "auf RR warten";
        case "secondChoice":
          return "Zweite Wahl";
        case "pendingMessageFK":
          return "auf FK warten";
        case "pool":
          return "in Pool aufnehmen";
        case "phone-call":
          return "Anrufen";
        case "request-documents":
          return "Unterlagen anfordern";
        case "waiting-for-documents":
          return "auf Unterlagen warten";
        case "waiting-for-response":
          return "Antwort abwarten";
        case "sarah":
          return "Sarah";
        case "lena":
          return "Lena";
        case "invite-to-trial-work":
          return "Probearbeit einladen";
        case "agreed-trial-work":
          return "Probearbeit vereinbart";
        case "create-contract":
          return "Vertrag erstellen";
        default:
          return "";
      }
    },
    async saveNotes() {
      updateDoc(doc(firestore, "application", this.personId), {
        notes: this.personData.notes,
      })
        .then(() => {
          this.message.success = "Die Notizen wurden erfolgreich gespeichert.";
          this.notesChanged = false;
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten. " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    async saveKeyword() {
      if (this.savedKeywords.some((keyword) => keyword.toLowerCase() === this.personData.keyword.toLowerCase())) {
        this.message.error = "Dieses Stichwort existiert bereits.";
        setTimeout(this.resetMessage, 3000);
        return;
      }
      updateDoc(doc(firestore, "application", this.personId), {
        keywords: arrayUnion(
          this.personData.keyword
        ),
      })
        .then(() => {
          this.message.success = "Das Stichwort wurde erfolgreich gespeichert.";
          this.personData.keyword = "";
          this.loadApplicationKeywords(this.personId);
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten. " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    async deleteKeyword(keyword) {
      const docRef = doc(firestore, "application", this.personId);
      try {
        await updateDoc(docRef, {
          keywords: arrayRemove(keyword),
        });
        this.message.success = "Das Stichwort wurde erfolgreich gelöscht.";
        this.loadApplicationKeywords(this.personId);
        setTimeout(this.resetMessage, 3000);
      } catch (error) {
        console.error("Fehler beim Löschen:", error);
        this.message.error = "Es ist ein Fehler beim Löschen aufgetreten. " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async loadApplicationKeywords(id) {
      const docRef = doc(firestore, "application", id);
      try {
        // Das Dokument abrufen
        const docSnap = await getDoc(docRef);

        // Prüfen, ob das Dokument existiert
        if (docSnap.exists()) {
          this.savedKeywords = docSnap.data().keywords || [];
        } else {
          console.log(`Kein Dokument mit dieser ID (${id}) gefunden!`);
        }
      } catch (error) {
        console.error("Fehler beim Abrufen des Dokuments:", error);
        this.message.error = "Es ist ein Fehler aufgetreten. " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async savePersonData() {
      try {
        await updateDoc(
          doc(firestore, "application", this.personId),
          this.personData,
        );
        this.changed = false;
        this.message.success =
          "Die Personendaten wurden erfolgreich gespeichert.";
        this.changePersonData = false;
        setTimeout(this.resetMessage, 3000);
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async handleCVUpload(event) {
      this.curriculumVitaeFile.file = event.target.files[0];
      this.curriculumVitaeFile.name = event.target.files[0].name.replace(
        /\s+/g,
        "_",
      );
    },
    async uploadCV() {
      if (!this.curriculumVitaeFile.file) {
        this.message.error = "Bitte wählen Sie eine Datei zum Hochladen aus.";
        setTimeout(this.resetMessage, 3000);
        return;
      }
      try {
        const storageRef = ref(
          storage,
          `curriculumVitae/${Date.now()}/${this.curriculumVitaeFile.name}`,
        );
        await uploadBytes(storageRef, this.curriculumVitaeFile.file).then(
          async (snapshot) => {
            await getDownloadURL(snapshot.ref).then(async (downloadURL) => {
              try {
                await updateDoc(doc(firestore, "application", this.personId), {
                  curriculumVitae: {
                    name: this.curriculumVitaeFile.name,
                    path: downloadURL,
                  },
                });
              } catch (error) {
                this.message.error = "Es ist ein Fehler aufgetreten: " + error;
                setTimeout(this.resetMessage, 3000);
              }
            });
            this.message.success =
              "Der Lebenslauf wurde erfolgreich hochgeladen.";
            setTimeout(this.resetMessage, 3000);
            this.curriculumVitaeURL = this.curriculumVitaeFile.path;
          },
        );
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      } finally {
        this.curriculumVitaeFile = {
          file: null,
          name: "",
        };
      }
    },
    async handleOtherDocumentsUpload(event) {
      this.otherDocumentsFiles = Array.from(event.target.files).map((file) => ({
        file: file,
        name: file.name,
      }));
    },
    async uploadPersonOtherDocuments() {
      if (this.otherDocumentsFiles.length === 0) {
        this.message.error = "Bitte wählen Sie Dateien zum Hochladen aus.";
        setTimeout(this.resetMessage, 3000);
        return;
      }
      try {
        const downloadURLs = [];
        for (const file of this.otherDocumentsFiles) {
          const storageRef = ref(
            storage,
            `otherDocuments/${Date.now()}/${file.name}`,
          );
          const snapshot = await uploadBytes(storageRef, file.file);
          const downloadURL = await getDownloadURL(snapshot.ref);
          downloadURLs.push({ name: file.name, path: downloadURL });
        }
        try {
          let existingDocs = null;
          await getDoc(doc(firestore, "application", this.personId)).then(
            async (docSnap) => {
              if (docSnap.exists()) {
                const docData = docSnap.data();
                existingDocs = docData.otherDocuments || [];
                if (existingDocs.length > 0) {
                  const updatedDocs = existingDocs.concat(downloadURLs);
                  await updateDoc(
                    doc(firestore, "application", this.personId),
                    { otherDocuments: updatedDocs },
                  );
                } else {
                  await updateDoc(
                    doc(firestore, "application", this.personId),
                    { otherDocuments: downloadURLs },
                  );
                }
              }
            },
          );
          this.message.success =
            "Die Dokumente wurden erfolgreich hochgeladen.";
          setTimeout(this.resetMessage, 3000);
          this.personData.otherDocuments = existingDocs
            ? existingDocs.concat(downloadURLs)
            : downloadURLs;
        } catch (error) {
          this.message.error = "Es ist ein Fehler aufgetreten: " + error;
          setTimeout(this.resetMessage, 3000);
        }
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      } finally {
        this.otherDocumentsFiles = [];
      }
    },
    async getMails() {
      const readMails = httpsCallable(functions, "readMailsOnCall");
      try {
        this.loadingMails = true;
        await readMails().then(() => {
          this.message.success = "E-Mails wurden erfolgreich abgerufen.";
          setTimeout(this.resetMessage, 3000);
          this.loadData();
        });
      } catch (error) {
        this.message.error = "Fehler beim Abrufen der E-Mails: " + error;
        setTimeout(this.resetMessage, 3000);
        console.log(error);
      } finally {
        this.loadingMails = false;
      }
    },
    getAnswerOfAl(mail) {
      if (!this.personData.repliesFromAl) {
        return "Bisher keine Antwort";
      }
      return (
        this.personData.repliesFromAl
          .filter((reply) => reply.mail === mail)
          .map((reply) => reply.answer + '; ' + reply.message)
          .join(" // ") || "Bisher keine Antwort"
      );
    },
    async addToEmployedArchive(id) {
      try {
        await updateDoc(doc(firestore, "application", id), {
          employedArchive: true,
          needReplyFrom: [],
        });
        this.message.success =
          "Die Person wurde erfolgreich zum Eingestellt-Archiv hinzugefügt.";
        this.formularModal = null;
        setTimeout(this.resetMessage, 3000);
        this.loadData();
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async setCouldAlsoFitFor() {
      try {
        await updateDoc(doc(firestore, "application", this.personId), {
          couldAlsoFitFor: this.personData.couldAlsoFitFor || [],
        });
        this.setCouldAlsoFitForActive = false;
        this.message.success = "Die Daten wurden erfolgreich gespeichert.";
        setTimeout(this.resetMessage, 3000);
      } catch (error) {
        this.setCouldAlsoFitForActive = false;
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async deleteCouldAlsoFitFor() {
      try {
        await updateDoc(doc(firestore, "application", this.personId), {
          couldAlsoFitFor: [],
        });
        this.setCouldAlsoFitForActive = false;
        this.loadData();
        this.message.success = "Die Daten wurden erfolgreich gespeichert.";
        setTimeout(this.resetMessage, 3000);
      } catch (error) {
        this.setCouldAlsoFitForActive = false;
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
    async removeNeedReplyFrom(email) {
      const convertedEmail = email.trim().toLowerCase();
      try {
        const docRef = doc(firestore, "application", this.personId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const docData = docSnap.data();
          if (!docData.needReplyFrom || docData.needReplyFrom.length === 0) {
            this.message.error = "Keine Antworten ausstehend.";
            setTimeout(this.resetMessage, 3000);
            return;
          } else {
            const needReplyFrom = docData.needReplyFrom;
            if (!needReplyFrom.includes(convertedEmail)) {
              this.message.error =
                "Diese E-Mail-Adresse ist nicht in der Liste der ausstehenden Antworten.";
              setTimeout(this.resetMessage, 3000);
              return;
            }
            await updateDoc(docRef, {
              needReplyFrom: arrayRemove(convertedEmail),
            });
            this.personData.needReplyFrom = needReplyFrom.filter(
              (email) => email !== convertedEmail,
            );
            this.replyEmail = "";
            this.removeOpenReply = false;
            this.message.success =
              "Die E-Mail-Adresse wurde erfolgreich aus der Liste der ausstehenden Antworten entfernt.";
            setTimeout(this.resetMessage, 3000);
          }
        }
      } catch (error) {
        this.message.error = "Es ist ein Fehler aufgetreten: " + error;
        setTimeout(this.resetMessage, 3000);
      }
    },
  },
  mounted() {
    this.loadData();
    this.loadJobOffers();
  },
};
</script>

<style scoped>
tr {
  cursor: pointer;
}

#personImage {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 5px;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  margin: 16px;
  width: 240px;
}

.printOnly {
  display: none;
}

.alert {
  z-index: 999999999;
}

.circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 5px;
}

.red {
  background-color: #ff4d4d;
}

.green {
  background-color: #4caf50;
}

.yellow {
  background-color: #ffeb3b;
}

.orange {
  background-color: #ff9800;
}

.turquoise {
  background-color: #40e0d0;
}

.grey {
  background-color: #9e9e9e;
}

.blue {
  background-color: #2196f3;
}

.white {
  background-color: #ffffff;
  border: 1px solid #d3d3d3;
}

.purple {
  background-color: #800080;
}

.brown {
  background-color: #a52a2a;
}

.lightgreen {
  background-color: #90ee90;
}

.black {
  background-color: #000000;
}

.magenta {
  background-color: #ff00ff;
}

.pink {
  background-color: #ffc0cb;
}

.lightblue {
  background-color: #add8e6;
}

.cyan {
  background-color: #00ffff;
}

.lightbrown {
  background-color: #a52a2a;
}

.lightgrey {
  background-color: #d3d3d3;
}

.lightcoral {
  background-color: #f08080;
}

.table-responsive {
  width: 100%;
  overflow-x: hidden;
}

.applications-table {
  table-layout: fixed;
  width: 100%;
}

.applications-table th,
.applications-table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.col-name {
  width: 15%;
}

.col-joboffer {
  width: 25%;
}

.col-department {
  width: 14%;
}

.col-incoming {
  width: 10%;
}

.col-status {
  width: 13%;
}

.col-keywords {
  width: 17%;
}

.col-action {
  width: 48px;
  white-space: nowrap;
  text-align: center;
}

.col-action .badge {
  white-space: nowrap;
}

.name-cell {
  max-width: 100%;
}

.joboffer-names {
  max-width: 100%;
}

.keyword-list {
  max-height: clamp(2rem, 2.9rem, 3rem);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  width: 100%;
}
</style>
<style>
#mail-editor-reference-message-container {
  display: none !important;
}
</style>
